import { toast } from 'react-toastify';
import { showToast } from '../toastMessage/ToastMessage';
import Cookies from 'js-cookie';
import { update } from 'lodash';
import { roundTo3 } from '@/pages/transaction/purchase/helpers';

const tolaWeightInGram = 11.664;
const tolaWeightInLal = 100;
const primaryCalculationType = Cookies.get('primaryCalculationType');

/**
 * function for converting gram weight into Lal
 * @param {*} value -> gram wt
 * @returns {Number} -> lal wt
 */

export const gramToLalConversion = (value) => {
  return Number(((value * tolaWeightInLal) / tolaWeightInGram).toFixed(1));
};

/**
 * function for converting gram weight into Lal
 * @param {*} value -> lal wt
 * @returns {Number} -> gm wt
 */

export const LalToGramConversion = (value) => {
  return Number(((value * tolaWeightInGram) / tolaWeightInLal).toFixed(3));
};
/**
 * Calculate the second form values and update the form and form data state.
 *
 * @param {Object} form - The form object to update fields.
 * @param {Object} formData - The current form data.
 * @param {Function} setFormData - Function to update the form data state.
 */
export const calculateSecondForm = (
  form,
  formData,
  setFormData,
  primaryCalculationType,
  pathName,
) => {
  const netWeight = Number(
    (
      (Number(form?.getFieldValue('grossWeight')) || 0) -
      (Number(form?.getFieldValue('diamondWeightGram')) || 0) -
      (Number(form?.getFieldValue('stoneWeightGram')) || 0)
    ).toFixed(3),
  );

  const wastageWeight = Number(form.getFieldValue('wastageWeight') || 0);
  // NetWeightGm is opposite of primaryCalculation type

  const netWeightGm =
    primaryCalculationType === 'lal'
      ? Number(
          (Number(form?.getFieldValue('grossWeightGm')) || 0) -
            (LalToGramConversion(form?.getFieldValue('diamondWeightGram')) ||
              0) -
            (LalToGramConversion(form?.getFieldValue('stoneWeightGram')) || 0),
        ).toFixed(3)
      : Number(
          (Number(form?.getFieldValue('grossWeightGm')) || 0) -
            (gramToLalConversion(form?.getFieldValue('diamondWeightGram')) ||
              0) -
            (gramToLalConversion(form?.getFieldValue('stoneWeightGram')) || 0),
        ).toFixed(1);

  const netWithWastage = Number((netWeight + wastageWeight).toFixed(3));
  const pureWeight = Number(
    (netWeight * (Number(formData?.purity) / 100)).toFixed(
      primaryCalculationType === 'lal' ? 1 : 3,
    ),
  );

  const pureWithWastage = Number(
    (pureWeight + Number(form.getFieldValue('wastageWeight') || 0)).toFixed(3),
  );

  const rateToChoose = pathName?.pathname?.includes('party');

  const isRouteForPureWithWastage =
    pathName?.pathname?.includes('/transaction/receive/karigar/create/') ||
    pathName?.pathname?.includes('/transaction/receive/karigar/edit/');

  // const calculateRate = Number(
  //   (
  //     Number(form.getFieldValue('purity') / 100) *
  //     (rateToChoose ? 0 : Number(form.getFieldValue('rate')) || 0)
  //   ).toFixed(3),
  // );
  const originalRate = form.getFieldValue('rate') || 0;
  const free_rate =
    ((Number(form.getFieldValue('purity')) || 0) / 100) *
    (rateToChoose ? 0 : originalRate);

  const calculateRate = roundTo3(free_rate || 0);

  // const calculateRate =
  //   ((Number(form.getFieldValue('purity')) || 0) / 100) *
  //   (form.getFieldValue('rate') || 0);

  // const roundedFreeRate = parseFloat(free_rate?.toFixed(3));
  // const roundedFreeRate = Number(free_rate?.toFixed(3) ?? 0);
  // const roundedFreeRate = parseFloat(free_rate || 0)?.toFixed(3);

  // const metalAmount = Number((pureWeight * Number(formData?.rate)).toFixed(3));

  const metalAmount = Number(
    (netWeight * (rateToChoose ? 0 : roundTo3(calculateRate || 0))).toFixed(3),
  );

  // Incase something went wrong with metal amount use below

  // const metalAmount = Number(
  //   (
  //     pureWeight * (rateToChoose ? 0 : Number(formData?.rate) || 0).toFixed(3)
  //   ).toFixed(3),
  // );
  // const netAmount = Number(
  //   (
  //     ((Number(formData?.purity) / 100) * netWithWastage).toFixed(3) *
  //       Number(form.getFieldValue('rate') || 0) +
  //     Number(form.getFieldValue('makingAmount') || 0) +
  //     Number(form.getFieldValue('stoneAmount') || 0) +
  //     Number(form.getFieldValue('extraAmount') || 0) +
  //     Number(form.getFieldValue('diamondAmount') || 0)
  //   ).toFixed(3),
  // );

  const isReceive = pathName?.pathname.includes('/transaction/receive');

  const isCalculatePure = form.getFieldValue('isPure') || false;

  let netAmount = 0;
  if (isCalculatePure) {
    netAmount =
      Number(
        (
          Number(
            pureWeight.toFixed(primaryCalculationType === 'lal' ? 1 : 3) *
              (isReceive ? 0 : originalRate),
          ) +
          Number(
            wastageWeight.toFixed(primaryCalculationType === 'lal' ? 1 : 3) *
              (isReceive ? 0 : originalRate),
          ) +
          Number(form.getFieldValue('makingAmount') || 0) +
          Number(form.getFieldValue('stoneAmount') || 0) +
          Number(form.getFieldValue('extraAmount') || 0) +
          Number(form.getFieldValue('diamondAmount') || 0) +
          Number(form.getFieldValue('roundOff') || 0)
        ).toFixed(3),
      ) || 0;
  } else {
    netAmount =
      Number(
        (
          Number(
            netWithWastage.toFixed(primaryCalculationType === 'lal' ? 1 : 3) *
              (isReceive ? 0 : calculateRate),
          ) +
          Number(form.getFieldValue('makingAmount') || 0) +
          Number(form.getFieldValue('stoneAmount') || 0) +
          Number(form.getFieldValue('extraAmount') || 0) +
          Number(form.getFieldValue('diamondAmount') || 0) +
          Number(form.getFieldValue('roundOff') || 0)
        ).toFixed(3),
      ) || 0;
  }

  form.setFieldsValue({
    netWeight:
      primaryCalculationType === 'lal'
        ? netWeight.toFixed(1)
        : netWeight.toFixed(3),
    netWeightGm: netWeightGm,
    // netWithWastage:
    //   primaryCalculationType === 'lal'
    //     ? netWithWastage.toFixed(1)
    //     : netWithWastage.toFixed(3),

    netWithWastage: isRouteForPureWithWastage
      ? primaryCalculationType === 'lal'
        ? pureWithWastage.toFixed(1)
        : pureWithWastage.toFixed(3)
      : primaryCalculationType === 'lal'
        ? netWithWastage.toFixed(1)
        : netWithWastage.toFixed(3),
    pureWeight:
      primaryCalculationType === 'lal'
        ? pureWeight.toFixed(1)
        : pureWeight.toFixed(3),
    metalAmount: metalAmount.toFixed(3) || 0,
    netAmount:
      form.getFieldValue('fixedAmount') === 'yes'
        ? form.getFieldValue('netAmount')
        : netAmount,
  });

  setFormData({
    ...formData,
    netAmount:
      form.getFieldValue('fixedAmount') === 'yes'
        ? formData?.netAmount
        : netAmount,
    netWeight:
      primaryCalculationType === 'lal'
        ? netWeight.toFixed(1)
        : netWeight.toFixed(3),
    netWithWastage:
      primaryCalculationType === 'lal'
        ? netWithWastage.toFixed(1)
        : netWithWastage.toFixed(3),
    metalAmount: metalAmount.toFixed(3),
    pureWeight:
      primaryCalculationType === 'lal'
        ? pureWeight.toFixed(1)
        : pureWeight.toFixed(3),
  });
};

/**
 * Handle field changes and validate specific fields.
 *
 * @param {string} fieldName - The name of the field being changed.
 * @param {string|number} value - The new value of the field.
 * @param {Object} formData - The current form data.
 * @param {Function} setFormData - Function to update the form data state.
 * @param {Function} purity - The new value of the field..
 */
export const handleFieldChange = (
  form,
  fieldName,
  value,
  formData,
  setFormData,
) => {
  if (fieldName === 'diamondWeightGram') {
    const diamondWeight = Number(value);
    const grossWeight = Number(form.getFieldValue('grossWeight'));
    if (
      !isNaN(diamondWeight) &&
      !isNaN(grossWeight) &&
      diamondWeight > grossWeight
    ) {
      toast.warn('Diamond weight cannot be greater than gross weight!');
    }
  } else if (fieldName == 'stoneWeightGram') {
    const stoneWeight = Number(value);
    const diamondWeight = Number(form.getFieldValue('diamondWeightGram'));
    const grossWeight = Number(form.getFieldValue('grossWeight'));
    const weightDifference = grossWeight - diamondWeight;
    if (
      !isNaN(diamondWeight) &&
      !isNaN(grossWeight) &&
      !isNaN(stoneWeight) &&
      weightDifference < stoneWeight
    ) {
      toast.warn(
        'Stone weight should not be less than the difference of gross weight and diamond weight',
      );
    }
  } else if (fieldName === 'calculationType' && value === 'custom') {
    form.setFieldsValue({
      ...formData,
      ...form.getFieldsValue(),
      rate: 0,
      [fieldName]: value || 0,
    });
    setFormData({
      ...formData,
      rate: 0,
      ...form.getFieldValue(),
      [fieldName]: value || 0,
    });
  } else if (
    fieldName === 'calculationType' &&
    (value === 'fifo' || value === 'goldrate' || value === 'average')
  ) {
    form.setFieldsValue({
      ...formData,
      ...form.getFieldsValue(),
      rate: formData?.goldRateToday || 0,
      [fieldName]: value || 0,
    });
    setFormData({
      ...formData,
      rate: formData?.goldRateToday || 0,
      ...form.getFieldValue(),
      [fieldName]: value || 0,
    });
  } else {
    form.setFieldsValue({
      ...formData,
      ...form.getFieldsValue(),
      [fieldName]: value || 0,
    });

    setFormData({
      ...formData,
      ...form.getFieldValue(),
      [fieldName]: value || 0,
    });
  }
};

export const handleGrossWeightToTola = (
  fieldName,
  value,
  formData,
  form,
  setFormData,
) => {
  const primaryCalculationType = Cookies.get('primaryCalculationType');

  ///previously data was from formData not form form.getFieldsValue()
  let updatedData = {
    ...formData,
    ...form.getFieldsValue(),
    [fieldName]: value,
  };
  if (fieldName === 'grossWeight') {
    updatedData.grossWeightGm =
      primaryCalculationType === 'lal'
        ? value
          ? LalToGramConversion(value).toFixed(3)
          : 0
        : value
          ? gramToLalConversion(value).toFixed(1)
          : 0;
  } else if (fieldName === 'grossWeightGm') {
    updatedData.grossWeight =
      primaryCalculationType === 'lal'
        ? value
          ? gramToLalConversion(value).toFixed(1)
          : 0
        : value
          ? LalToGramConversion(value).toFixed(3)
          : 0;
  }

  setFormData(updatedData);
  form.setFieldsValue(updatedData);
};

export const handleGrossWeightToTolaNegative = (
  fieldName,
  value,
  formData,
  form,
  setFormData,
) => {
  const primaryCalculationType = Cookies.get('primaryCalculationType');

  const isValidNumber = value !== null && value !== undefined && !isNaN(value);

  const updatedData = {
    ...formData,
    ...form.getFieldsValue(),
    [fieldName]: value,
  };

  if (fieldName === 'grossWeight') {
    updatedData.grossWeightGm =
      primaryCalculationType === 'lal'
        ? isValidNumber
          ? LalToGramConversion(Number(value)).toFixed(3)
          : 0
        : isValidNumber
          ? gramToLalConversion(Number(value)).toFixed(1)
          : 0;
  } else if (fieldName === 'grossWeightGm') {
    updatedData.grossWeight =
      primaryCalculationType === 'lal'
        ? isValidNumber
          ? gramToLalConversion(Number(value)).toFixed(1)
          : 0
        : isValidNumber
          ? LalToGramConversion(Number(value)).toFixed(3)
          : 0;
  }

  setFormData(updatedData);
  form.setFieldsValue(updatedData);
};

/**
 * Handle purity changes and update the form data accordingly.
 *
 * @param {string} fieldName - The name of the field being changed.
 * @param {string|number} value - The new value of the field.
 * @param {Object} formData - The current form data.
 * @param {Function} setFormData - Function to update the form data state.
 */
// export const handlePurity = (fieldName, value, formData, setFormData, form) => {
//   if (fieldName === 'crt') {
//     const caratValue = Number(value);
//     if (caratValue > 24) {
//       showToast('Crt value cannot be more then 24', 'warn');
//     }
//     if (!isNaN(caratValue) && caratValue <= 24) {
//       const percentage = Number((caratValue * 100) / 24);
//       setFormData({
//         ...formData,
//         crt: value,
//         purity: Number(percentage).toFixed(3),
//       });
//       form.setFieldsValue({
//         crt: value,
//         purity: Number(percentage).toFixed(3),
//       });
//     }
//   } else if (fieldName === 'purity') {
//     const percentageValue = Number(value);
//     if (!isNaN(percentageValue) && percentageValue <= 100) {
//       const carat = (percentageValue * 24) / 100;
//       setFormData({
//         ...formData,
//         crt: Number(carat).toFixed(3),
//         purity: Number(value),
//       });
//       form.setFieldsValue({
//         purity: value,
//         crt: Number(carat).toFixed(3),
//       });
//     }
//   }
// };
export const handlePurity = (fieldName, value, formData, setFormData, form) => {
  if (fieldName === 'crt') {
    if (!/^\d*\.?\d{0,3}$/.test(value)) return; // Allow up to 3 decimal places

    const caratValue = parseFloat(value);
    if (!isNaN(caratValue)) {
      if (caratValue > 24) {
        showToast('Crt value cannot be more than 24', 'warn');
        return;
      }

      const percentage = (caratValue * 100) / 24;
      setFormData({
        ...formData,
        crt: value, // Keep raw input
        purity: percentage.toFixed(3), // Ensure 3 decimal places
      });
      form.setFieldsValue({
        crt: value,
        purity: percentage.toFixed(3),
      });
    } else {
      setFormData({ ...formData, crt: value, purity: '' });
      form.setFieldsValue({ crt: value, purity: '' });
    }
  } else if (fieldName === 'purity') {
    if (!/^\d*\.?\d{0,3}$/.test(value)) return; // Allow up to 3 decimal places

    const percentageValue = parseFloat(value);
    if (!isNaN(percentageValue)) {
      if (percentageValue > 100) {
        showToast('Purity cannot be more than 100%', 'warn');
        return;
      }

      const carat = Math.round((percentageValue * 24) / 100);
      setFormData({
        ...formData,
        crt: carat,
        purity: value, // Keep raw input
      });
      form.setFieldsValue({
        purity: value,
        crt: carat,
      });
    } else {
      setFormData({ ...formData, purity: value, crt: '' });
      form.setFieldsValue({ purity: value, crt: '' });
    }
  }
};

/**
 * Calculate percentage value for making charge and update the form and form data state.
 *
 * @param {Object} form - The form object to update fields.
 * @param {Object} formData - The current form data.
 * @param {Function} setFormData - Function to update the form data state.
 * @param {Object} salesDescription - The current sales description data.
 * @param {Function} setSalesDescription - Function to update the sales description state.
 */

export const CalculatePercentageValue = (form, formData, setFormData) => {
  if (form.getFieldValue('makingChargeType') === 'percentage') {
    const percent =
      (Number(form.getFieldValue('grossWeight')) *
        Number(
          (
            (Number(form.getFieldValue('purity')) / 100) *
            Number(form.getFieldValue('rate'))
          ).toFixed(3),
        ) *
        Number(form.getFieldValue('makingCharge'))) /
      100;
    setFormData({
      ...formData,
      ...form.getFieldsValue(),
      makingAmount: percent?.toFixed(3),
    });
    form.setFieldsValue({
      ...form.getFieldsValue(),
      makingAmount: percent?.toFixed(3),
    });
  } else if (form.getFieldValue('makingChargeType') === 'rate') {
    const value =
      Number(form.getFieldValue('makingCharge')) *
      Number(form.getFieldValue('grossWeight'));
    setFormData({
      ...formData,
      ...form.getFieldsValue(),
      makingAmount: value?.toFixed(3),
    });
    form.setFieldsValue({
      ...form.getFieldsValue(),
      makingAmount: value?.toFixed(3),
    });
  }
};

/**
 * Calculate wastage weight based on the wastage type and update the form and form data state.
 *
 * @param {Object} form - The form object to update fields.
 * @param {Object} formData - The current form data.
 * @param {Function} setFormData - Function to update the form data state.
 */

export const thirdFormBoxCalculation = (form, formData, setFormData) => {
  let wastageWeight = Number(form.getFieldValue('wastageWeight')) || 0;
  if (form.getFieldValue('wastageType') === 'gw') {
    wastageWeight =
      (form.getFieldValue('grossWeight') *
        Number(form.getFieldValue('wastageCharge'))) /
      100;
  } else if (form.getFieldValue('wastageType') === 'nw') {
    wastageWeight =
      (form.getFieldValue('netWeight') *
        Number(form.getFieldValue('wastageCharge'))) /
      100;
  } else if (form.getFieldValue('wastageType') === 'pw') {
    wastageWeight =
      (form.getFieldValue('pureWeight') *
        Number(form.getFieldValue('wastageCharge'))) /
      100;
  }
  setFormData({
    ...formData,
    ...form.getFieldsValue(),
    wastageWeight: wastageWeight.toFixed(
      primaryCalculationType === 'lal' ? 1 : 3,
    ),
  });
  form.setFieldsValue({
    ...formData,
    ...form.getFieldsValue(),
    wastageWeight: wastageWeight.toFixed(
      primaryCalculationType === 'lal' ? 1 : 3,
    ),
  });
};

/**
 *  calculate gold price of the 22k and 18k with help of 24k gold price
 */

export const calculateTwentyTwoCaratPrice = (price) =>
  ((Number(price) * 91.66) / 100).toFixed(3);

export const calculateEighteenCaratPrice = (price) =>
  ((Number(price) * 75) / 100).toFixed(3);

/**
 * This is used to fetched the data for editing on any codewindow.
 * Handles the new row data and updates the form and table data accordingly.
 *
 * @param {Object} newRowData - The new row data to handle.
 * @param {Object} form - The Ant Design form instance.
 * @param {Function} setFormData - Function to update the form data state.
 * @param {Function} setTableData - Function to update the table data state.
 */

export const handleNewRowData = (
  newRowData,
  form,
  setFormData,
  setTableData,
) => {
  setTableData([{ key: 1 }]);
  if (newRowData) {
    if (newRowData?.diamondStones) {
      form.setFieldsValue(newRowData);
      setFormData(newRowData);

      // setTableData(
      //   (newRowData?.diamondStones?.length && newRowData?.diamondStones) || [
      //     { key: 1 },
      //   ],
      // );
      if (newRowData?.diamondStones?.length) {
        setTableData((prev) => {
          // Use map to dynamically assign a key to each item in the diamondStones array
          const updatedData = newRowData?.diamondStones?.map((item, index) => ({
            ...item,
            key: index + 1, // Dynamically set the key based on the index
          })) || [{ key: 1 }]; // Default value if diamondStones is empty

          return updatedData;
        });
      }
    }
    if (!newRowData.new && newRowData?.finalData?.detailsJson?.length) {
      const firstPurchaseDetail = newRowData.finalData?.detailsJson[0];
      form.setFieldsValue(firstPurchaseDetail);
      setFormData(firstPurchaseDetail);
      // setTableData(
      //   (newRowData?.finalData?.diamondStoneJson?.length &&
      //     newRowData?.finalData?.diamondStoneJson) || [{ key: 1 }],
      // );
      if (newRowData?.finalData?.diamondStoneJson?.length) {
        setTableData(() => {
          // Dynamically assign keys if diamondStoneJson exists and has data
          const updatedData = newRowData?.finalData?.diamondStoneJson?.map(
            (item, index) => ({
              ...item,
              key: index + 1, // Assign unique keys based on the index
            }),
          ) || [{ key: 1 }]; // Fallback to a default object if the array is empty or undefined

          return updatedData;
        });
      }
    }

    if (!newRowData.new && newRowData.purchaseData?.issueDetailsJson?.length) {
      const firstPurchaseDetail = newRowData.purchaseData?.issueDetailsJson[0];
      form.setFieldsValue(firstPurchaseDetail);
      setFormData(firstPurchaseDetail);
      // setTableData(
      //   (newRowData?.purchaseData?.diamondStoneJson?.length &&
      //     newRowData?.purchaseData?.diamondStoneJson) || [{ key: 1 }],
      // );
      if (newRowData?.purchaseData?.diamondStoneJson?.length) {
        setTableData(() => {
          // Dynamically assign keys if diamondStoneJson exists and has data
          const updatedData = newRowData?.purchaseData?.diamondStoneJson?.map(
            (item, index) => ({
              ...item,
              key: index + 1, // Assign unique keys based on the index
            }),
          ) || [{ key: 1 }]; // Fallback to a default object if the array is empty or undefined
          return updatedData;
        });
      }
    }
    if (!newRowData.new && newRowData.issueData?.detailsJson?.length) {
      const firstPurchaseDetail = newRowData.issueData?.detailsJson[0];
      form.setFieldsValue(firstPurchaseDetail);
      setFormData(firstPurchaseDetail);
      // setTableData(
      //   (newRowData?.issueData?.diamondStoneJson?.length &&
      //     newRowData?.issueData?.diamondStoneJson) || [{ key: 1 }],
      // );
      if (newRowData?.issueData?.diamondStoneJson?.length) {
        setTableData(() => {
          // Dynamically assign keys if diamondStoneJson exists and has data
          const updatedData = newRowData?.issueData?.diamondStoneJson?.map(
            (item, index) => ({
              ...item,
              key: index + 1, // Assign unique keys based on the index
            }),
          ) || [{ key: 1 }]; // Fallback to a default object if the array is empty or undefined
          return updatedData;
        });
      }
    }
  }
};

export const handleImageChange = (info) => {
  if (info.file.status === 'done' || info.file.originFileObj) {
    const imageUrl = URL.createObjectURL(info.file.originFileObj);
    setFormData((prevData) => ({ ...prevData, image: imageUrl }));
    message.success(`${info.file.name} uploaded successfully`);
  } else if (info.file.status === 'error') {
    message.error(`${info.file.name} upload failed.`);
  }
};
export const formatNumber = (num, decimalPlaces = 3) => {
  const fixedNum = num?.toFixed(decimalPlaces); // Fix to given decimal places
  return parseFloat(fixedNum); // Remove trailing zeros while keeping meaningful decimals
};

export const formatNumberWithComma = (num, decimalPlaces = 3) => {
  // Fix to given decimal places
  if (isNaN(num)) return num;
  return roundTo3(num).toLocaleString('en-IN'); // Remove trailing zeros while keeping meaningful decimals
};
